import axios from "axios";
import { BASE_URL } from "../../assets/constant";
import { createHeaders } from "../../utils/Utils";

export const getDepartmentListAPI = async () => {
  const headers = createHeaders();
  return await axios.get(`${BASE_URL}admin/master/departments`, headers);
};
export const createDepartmentAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}admin/master/departments`, data, headers);
};

export const updateDepartmentAPI = async (data) => {
  const headers = createHeaders();
  return await axios.put(`${BASE_URL}admin/master/departments/${data?.department_id}/`, data, headers);
};
export const updateDepartmentStatusAPI = async (data) => {
  const headers = createHeaders();
  return await axios.patch(`${BASE_URL}admin/master/departments/${data?.department_id}/status`, data, headers);
};
